import React from "react";
const MainFooter = () => {
  return (
    <div className="container fixed-bottom">
      <footer className="d-flex bg-primary my-auto">
        <span className="col-md-12 text-center mt-3">
          <div className="col-md-9 text-center">
            سامانه پیامکی سایه بان - &copy; 1398/06/15
          </div>
          <div className="col-md-3 text-right">
            {/* <a
              referrerPolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=214184&Code="
            >
              <img
                referrerPolicy="origin"
                src="https://trustseal.enamad.ir/logo.aspx?id=214184&Code="
                alt=""
                style={{ cursor: "pointer" }}
                code
              />
            </a> */}
            <a
              referrerPolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=214184&amp;Code=oMgLVe0rzb0EPj2tmOHZ"
            >
              <img
                referrerPolicy="origin"
                src="images/LogoEnamad.png"
                alt=""
                style={{ cursor: "pointer" }}
                code="oMgLVe0rzb0EPj2tmOHZ"
              />
            </a>
          </div>
        </span>
      </footer>
    </div>
  );
};

export default MainFooter;
